(() => {
  'use strict';
  function initialise(root) {
    root.querySelectorAll('.g-real-purchase').forEach(form => {
      if (form.dataset.initialised) return;
      form.dataset.initialised = 'true';
      const data = form.querySelector('[data-unit-price]');
      const toggle = form.querySelector('[data-subscription-toggle]');
      const plan = form.querySelector('[data-selling-plan]');
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: data.dataset.currency || 'EUR'}).format(cents / 100);
      const singleMonthly = form.querySelector('[data-us-monthly-single]')?.value === 'true';
      const update = event => {
        if (singleMonthly && toggle?.checked) {
          if (event?.target === toggle) form.querySelector('[name="quantity"][value="1"]').checked = true;
          else if (form.querySelector('[name="quantity"]:checked')?.value !== '1') toggle.checked = false;
        }
        const subscribed = Boolean(toggle?.checked && plan);
        if (plan) {
          plan.disabled = !subscribed;
          plan.closest('label').hidden = true;
        }
        const summary = form.querySelector('[data-subscription-summary]');
        if (summary) { summary.hidden = !subscribed; summary.querySelector('[data-subscription-plan-name]').textContent = plan?.selectedOptions[0]?.textContent || ''; }
        const price = subscribed ? Number(plan.selectedOptions[0].dataset.price) : Number(data.dataset.unitPrice);
        const quantity = form.querySelector('[name="quantity"]:checked').value;
        form.querySelectorAll('[data-pack-price]').forEach(element => {
          const packQuantity = Number(element.dataset.quantity);
          const paid = Number(element.dataset.paid);
          const packPrice = singleMonthly && packQuantity !== 1 ? Number(data.dataset.unitPrice) : price;
          const total = packPrice * paid;
          const comparison = Number(element.dataset.compare);
          const saving = comparison > total ? Math.round((1 - total / comparison) * 100) : 0;
          element.closest('label').querySelector('[data-pack-saving]').textContent = saving ? `${data.dataset.savingLabel} ${saving}%` : ''; 
          element.textContent = money(total);
          if (element.dataset.quantity === quantity) {
            const section = form.closest('[data-product]');
            form.querySelector('[data-purchase-total]').textContent = money(total);
            const sticky = section.querySelector('[data-sticky-price]');
            if (sticky) sticky.textContent = money(total);
            section.querySelector('[data-selected-price]').textContent = money(total);
            [section.querySelector('[data-selected-compare]'), form.querySelector('[data-button-compare]')].forEach(node => { node.textContent = money(comparison); node.hidden = comparison <= total; });
            const badge = section.querySelector('[data-selected-saving]');
            badge.textContent = `${data.dataset.saleLabel} ${saving}%`;
            badge.hidden = !saving;
          }
        });
      };
      form.addEventListener('change', update);
      update();
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();


